'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapioComponentReducer = exports.MapioComponent = exports.removeFeatureProperties = exports.addFeatureProperties = exports.FeatureEditorActions = exports.FeatureEditorReducer = exports.FeatureEditor = exports.MapActions = exports.MapReducer = exports.Map = undefined;

var _Map = require('./Map');

Object.defineProperty(exports, 'Map', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Map).default;
  }
});

var _MapReducer = require('./MapReducer');

Object.defineProperty(exports, 'MapReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MapReducer).default;
  }
});

var _FeatureEditor = require('./FeatureEditor');

Object.defineProperty(exports, 'FeatureEditor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FeatureEditor).default;
  }
});

var _FeatureEditorReducer = require('./FeatureEditorReducer');

Object.defineProperty(exports, 'FeatureEditorReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FeatureEditorReducer).default;
  }
});

var _MapioComponent = require('./MapioComponent');

Object.defineProperty(exports, 'MapioComponent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MapioComponent).default;
  }
});

var _MapioComponentReducer = require('./MapioComponentReducer');

Object.defineProperty(exports, 'MapioComponentReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MapioComponentReducer).default;
  }
});

var _utils = require('./utils');

var _MapActions2 = require('./MapActions');

var _MapActions = _interopRequireWildcard(_MapActions2);

var _FeatureEditorActions2 = require('./FeatureEditorActions');

var _FeatureEditorActions = _interopRequireWildcard(_FeatureEditorActions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MapActions = _MapActions;
exports.FeatureEditorActions = _FeatureEditorActions;
exports.addFeatureProperties = _utils.addFeatureProperties;
exports.removeFeatureProperties = _utils.removeFeatureProperties;

// Deprecated komponenty, exportujeme pouze pro zpětnou kompatibilitu
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvbWFwaW8vaW5kZXguanN4Il0sIm5hbWVzIjpbImRlZmF1bHQiLCJNYXBBY3Rpb25zIiwiRmVhdHVyZUVkaXRvckFjdGlvbnMiLCJhZGRGZWF0dXJlUHJvcGVydGllcyIsInJlbW92ZUZlYXR1cmVQcm9wZXJ0aWVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7d0NBRVFBLE87Ozs7Ozs7OzsrQ0FDQUEsTzs7Ozs7Ozs7O2tEQUdBQSxPOzs7Ozs7Ozs7eURBQ0FBLE87Ozs7Ozs7OzttREFNQUEsTzs7Ozs7Ozs7OzBEQUNBQSxPOzs7O0FBZFI7Ozs7Ozs7Ozs7Ozs7O1FBSVlDLFU7UUFJQUMsb0I7UUFFSkMsb0IsR0FBQUEsMkI7UUFBc0JDLHVCLEdBQUFBLDhCOztBQUU5QiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7YWRkRmVhdHVyZVByb3BlcnRpZXMsIHJlbW92ZUZlYXR1cmVQcm9wZXJ0aWVzfSBmcm9tICcuL3V0aWxzJztcblxuZXhwb3J0IHtkZWZhdWx0IGFzIE1hcH0gZnJvbSBcIi4vTWFwXCJcbmV4cG9ydCB7ZGVmYXVsdCBhcyBNYXBSZWR1Y2VyfSBmcm9tICcuL01hcFJlZHVjZXInO1xuZXhwb3J0ICogYXMgTWFwQWN0aW9ucyBmcm9tIFwiLi9NYXBBY3Rpb25zXCJcblxuZXhwb3J0IHtkZWZhdWx0IGFzIEZlYXR1cmVFZGl0b3J9IGZyb20gXCIuL0ZlYXR1cmVFZGl0b3JcIlxuZXhwb3J0IHtkZWZhdWx0IGFzIEZlYXR1cmVFZGl0b3JSZWR1Y2VyfSBmcm9tICcuL0ZlYXR1cmVFZGl0b3JSZWR1Y2VyJztcbmV4cG9ydCAqIGFzIEZlYXR1cmVFZGl0b3JBY3Rpb25zIGZyb20gXCIuL0ZlYXR1cmVFZGl0b3JBY3Rpb25zXCJcblxuZXhwb3J0IHthZGRGZWF0dXJlUHJvcGVydGllcywgcmVtb3ZlRmVhdHVyZVByb3BlcnRpZXN9O1xuXG4vLyBEZXByZWNhdGVkIGtvbXBvbmVudHksIGV4cG9ydHVqZW1lIHBvdXplIHBybyB6cMSbdG5vdSBrb21wYXRpYmlsaXR1XG5leHBvcnQge2RlZmF1bHQgYXMgTWFwaW9Db21wb25lbnR9IGZyb20gXCIuL01hcGlvQ29tcG9uZW50XCJcbmV4cG9ydCB7ZGVmYXVsdCBhcyBNYXBpb0NvbXBvbmVudFJlZHVjZXJ9IGZyb20gJy4vTWFwaW9Db21wb25lbnRSZWR1Y2VyJztcbiJdfQ==